import React, { createContext, useReducer, useState } from 'react'
import { ResourceReducer } from './ResourceReducer'
import {
  apiUrl,
  RESOURCES_LOADED_SUCCESS,
  RESOURCES_LOADED_FAIL,
  RESOURCE_LOADED_SUCCESS,
  RESOURCE_LOADED_FAIL,
  RESOURCES_SEARCH_SUCCESS,
  DELETE_RESOURCE
} from '../constants/constants'
import axios from 'axios'
export const ResourceContext = createContext()

const ResourceContextProvider = ({ children }) => {
  const [resourceState, dispatch] = useReducer(ResourceReducer, {
    resource: null,
    resources: [],
    resourcesSearch: [],
    resourcesLoading: true
  })

  const [showToast, setShowToast] = useState({
    show: false,
    message: '',
    type: null
  })

  //get user
  // const getUser = async (id) => {
  //   try {
  //     const res = await axios.get(`${apiUrl}/user/find/${id}`, {
  //       headers: {
  //         token:
  //           'Bearer ' + JSON.parse(localStorage.getItem('user')).accessToken
  //       }
  //     })

  //     if (res.data.success) {
  //       userState.status = true
  //       dispatch({ type: USER_LOADED_SUCCESS, payload: res.data.info })
  //     }
  //   } catch (error) {
  //     dispatch({ type: USER_LOADED_FAIL })
  //   }
  // }

  //get movies
  const filterBySearch = async (data, query) => {
    // Access input value

    var updatedList = resourceState.resources

    // Include all elements which includes the search query
    updatedList = updatedList.filter(
      (item) => item.title.toLowerCase().indexOf(query.toLowerCase()) !== -1
    )
    dispatch({
      type: RESOURCES_SEARCH_SUCCESS,
      payload: updatedList
    })
    // setSearchResources(updatedList)
  }
  const getAllResources = async () => {
    try {
      const res = await axios.get(`${apiUrl}/affiliate/getAllResources`)
      // console.log(res.data.data)
      if (res.data.success) {
        //resourceState.resources = res.data.data
        dispatch({
          type: RESOURCES_LOADED_SUCCESS,
          payload: res.data.data
        })
      }
    } catch (error) {
      dispatch({ type: RESOURCES_LOADED_FAIL })
    }
  }

  //add post
  // const addUser = async (newUser) => {
  //   try {
  //     const response = await axios.post(`${apiUrl}/users/`, newUser)

  //     if (response.data.success) {
  //       dispatch({ type: ADD_USER })
  //       return
  //     }
  //   } catch (error) {
  //     dispatch({ type: ADD_USER_FAIL })
  //   }
  // }

  //update user
  // const updateUser = async (id, newUser) => {
  //   try {
  //     const hUser = {
  //       email: newUser.email,
  //       password: newUser.password,
  //       isAdmin: newUser.isAdmin,
  //       name: newUser.fullName
  //     }

  //     const response = await axios.put(`${apiUrl}/user/${id}`, hUser, {
  //       headers: {
  //         token:
  //           'Bearer ' + JSON.parse(localStorage.getItem('user')).accessToken
  //       }
  //     })
  //     console.log(response)
  //     if (response.data.success) {
  //       dispatch({ type: UPDATE_USER })
  //       return response.data
  //     }
  //   } catch (error) {
  //     return error.response.data
  //     dispatch({ type: UPDATE_USER_FAIL })
  //   }
  // }

  //delete user

  const deleteResource = async (resourceId) => {
    try {
      const response = await axios.delete(
        `${apiUrl}/affiliate/deleteResource/${resourceId}`
      )
      if (response.data.success) {
        dispatch({ type: DELETE_RESOURCE, payload: resourceId })
        window.location.reload()
        return response.data
      }
    } catch (error) {
      console.log(error)
    }
  }

  //context data
  const ResourceContextData = {
    resourceState,
    deleteResource,
    // addUser,
    getAllResources,
    filterBySearch,
    // getUser,
    // updateUser,
    showToast,
    setShowToast
    // deleteUser
    // addTodo,
    // deleteTodo,
  }
  return (
    <ResourceContext.Provider value={ResourceContextData}>
      {children}
    </ResourceContext.Provider>
  )
}

export default ResourceContextProvider
